import React, { useRef, useState, useEffect } from 'react';
import styles from '../thaisornellas_bolos/thaisornellas_bolos.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import FacebookIcon from '../../icons/facebookIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import catalogoPdf from './src/catalogo-thaisornellas_bolos.pdf';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Thaisornellas_bolos: React.FC = () => {

    return (
        <div className={styles.thaisornellas_bolos}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>THAIS ORNELLAS BOLOS</h1>
                    <p className="mb-0">
                        🎂 Bolos para festa
                    </p>
                    <p className="mb-0">
                        🥮 Bolos caseirinhos
                    </p>
                    <p>
                        🍰 Fatias de bolo a pronta entrega
                    </p>
                    <div className={styles.links}>
                        <Link
                            href="https://www.instagram.com/thaisornellas_bolos?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon color="#412016" height="32" />}
                            backgroundColor="#FFC8EB"
                            backgroundColorHover="#e39ac9"
                            colorText="#412016"
                        />
                        <Link
                            href="https://www.facebook.com/share/19oahqEVgG/?mibextid=wwXIfr"
                            title="Facebook"
                            icon={<FacebookIcon color="#412016" height="32" />}
                            backgroundColor="#FFC8EB"
                            backgroundColorHover="#e39ac9"
                            colorText="#412016"
                        />
                        <Link
                            href="https://wa.me/5517991965106"
                            title="Whatsapp"
                            icon={<WhatsappIcon color="#412016" height="40" />}
                            backgroundColor="#FFC8EB"
                            backgroundColorHover="#e39ac9"
                            colorText="#412016"
                        />
                        <Link
                            href={catalogoPdf}
                            title="Catálogo"
                            icon={<CatalogIcon color="#412016" height="35" />}
                            backgroundColor="#FFC8EB"
                            backgroundColorHover="#e39ac9"
                            colorText="#412016"
                        />
                        <Link
                            href="https://maps.app.goo.gl/QiP8qDBNAggtu2GV9"
                            title="Localização"
                            icon={<MapsIcon color="#412016" height="40" />}
                            backgroundColor="#FFC8EB"
                            backgroundColorHover="#e39ac9"
                            colorText="#412016"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Thaisornellas_bolos;
